export const PAGE_CONFIG = {
  Calllog_Page: "/assets/page-configs/call-log-list.json",
  Adhikari_Page: "/assets/page-configs/adhikari-list.json",
  Connector_page: "/assets/page-configs/connector-list.json",
  Daura_Page: "/assets/page-configs/daura-list.json",
  //GlobalSearcg_Page:"/assets/page-configs/list-data.json"
  Karyakarta_Page: "/assets/page-configs/karyakarta-list.json",
  MLAfund_Page: "/assets/page-configs/mla-fund-mgmt-list.json",
  Register_Page: "/assets/page-configs/register-book-list.json",
  Schedule_Page: "/assets/page-configs/schedule-book-list.json",
  Superadmin_Page: "/assets/page-configs/super-admin-list.json",
  Systemmenu_Page: "/assets/page-configs/system-menu-list.json",
  Permissionmenu_Page: "/assets/page-configs/role-list.json",
  Userdetail_Page: "/assets/page-configs/user-management.json",
  Vikaskame_Page: "/assets/page-configs/vikas-kame-list.json",
  Visitor_Page: "/assets/page-configs/visitor-list.json",
  Tokengen_Page: "/assets/page-configs/token-generation-list.json",
  Voter_Page: "/assets/page-configs/voter-data-import.json",
  Complaint_Page: "/assets/page-configs/complain-list.json",
  Viewer_Page: "/assets/page-configs/viewer-list.json",
  Office_page: "/assets/page-configs/office-list.json",
  Visit_page: "/assets/page-configs/visits-list.json",
  Task_My_Day: "/assets/page-configs/task-my-day.json",
  Task_Assigned_To_Me: "/assets/page-configs/task-assigned-to-me.json",
  Task_Multiple_List: "/assets/page-configs/task-multipal-list.json",
  Volunteer_Page: "/assets/page-configs/volunteer-list.json",
};
